jQuery(document).foundation();

// Mobile Nav

jQuery(document).ready(function($){
  $('#nav-icon-container').click(function(){
    $(this).toggleClass('fixed');
  });
});

jQuery(document).ready(function($){
  $('#nav-icon').click(function(){
    $(this).toggleClass('open');
  });
});

// Search

jQuery( document ).ready(function() {
  jQuery(".search-toggle").click(function(){
    jQuery(".search-box").toggle();
    jQuery(".search-input").focus();
    jQuery(this).toggleClass('active');
  });
});

// Counter

jQuery(document).ready(function($){
  $(".counter").each(function(index, element) {
    var count = $(this),
        zero = {val:0},
        num = count.data("number"),
        split = (num + "").split("."),
        decimals = split.length > 1 ? split[1].length : 0;

      gsap.to(zero, {
        val: num,
        duration: 2,
        scrollTrigger: element,
        onUpdate:countNumber})
    function countNumber() {
      var final = gsap.utils.snap(.01, zero.val);
      count.text(final);
        }
      });
  });

// Image Fade In On Scroll

jQuery(document).ready(function($){

gsap.set('.wp-block-image', {
  opacity: 0,
  scale: .5,
  x: 1000
})

const boxes = gsap.utils.toArray('.wp-block-image');
boxes.forEach(box => {
  gsap.to(box, { 
    opacity: 1,
    scale: 1,
    x: 0,
    duration: 1,
    ease: "power4.out",
    scrollTrigger: {
      trigger: box,
      start: "bottom bottom",
      end: "top 30%",
      scrub: false
    }
  })
});
});

